import { Button } from "antd";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useHttp } from "~hooks/useHttp";
import { useNotification } from "~hooks/useNotification";

const EditButton = ({ handleGetFormData }) => {
  const { sport, organizationId, standingsAdjustmentId } = useParams();
  const { formatMessage } = useIntl();
  const { loading, error, request, cleanError } = useHttp();
  const notification = useNotification();

  useEffect(() => {
    if (error) {
      notification.error({
        message: formatMessage({ id: 'standings.adjustment.update.error' }),
        description: error,
        placement: "bottomRight",
      });
      cleanError();
    }
  }, [cleanError, error, formatMessage]);

  const updateStandingsAdjustments = async (data) => {
    try {
      await request({
        url: `/v1/${sport}/o/${organizationId}/standings/adjustments/${standingsAdjustmentId}`,
        method: "PUT",
        body: data,
      });
      notification.success({
        message: formatMessage({ id: 'standings.adjustment.update.success' }),
        placement: "bottomRight",
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleUpdate = async () => {
    const data = await handleGetFormData();
    updateStandingsAdjustments(data);
  };

  return (
    <div style={{ textAlign: "center" }} className={"mt-3"}>
      <Button loading={loading} type={"primary"} size={"large"} onClick={handleUpdate}>
        {formatMessage({
          id: "standings.adjustment.edit",
          defaultMessage: "Submit changes",
        })}
      </Button>
    </div>
  );
};

export default EditButton;
